import { useState, useEffect, useContext, Fragment } from "react";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import { callApi, blockEmoji } from "bodycodi/cmap/app/js/common";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { StateContext as HomeStateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import MemberEmpty from "bodycodi/cmap/app/components/cmap3020/MemberEmpty";
import MemberDtl from "bodycodi/cmap/app/components/cmap3020/memberDtl";
import CenterList from "bodycodi/cmap/app/components/cmap3020/centerList";
import Memo from "bodycodi/cmap/app/components/common/Memo";
import PassList from "bodycodi/cmap/app/components/cmap3020/passList";

const MemberDtlPop = () => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const { state } = useContext(HomeStateContext);
  const { dispatch } = useContext(DispatchContext);
  const [memo, setMemo] = useState<string>("");
  const [memoReadOnly, setMemoReadOnly] = useState<string>("");
  const [memberDtl, setMemberDtl] = useState<any>({
    MemberDtlVO: {},
    PartnerVO: {},
    ClassPassList: [],
    AppointPassList: [],
    PlacePassList: [],
    OptionPassList: [],
    PackageInfo: new Map(),
    discountPermission: null,
    salePermission: null,
  });
  const {
    MemberDtlVO,
    PartnerVO,
    ClassPassList,
    AppointPassList,
    PlacePassList,
    OptionPassList,
    PackageInfo,
    discountPermission,
    salePermission,
  } = memberDtl;

  const processPassList = (PassList: any) => {
    const classPassList: any = [];
    const appointPassList: any = [];
    const placePassList: any = [];
    const optionPassList: any = [];
    const packageInfo: any = new Map();

    PassList.forEach((pass: any) => {
      switch (pass.serviceType) {
        case "APPOINTMENT":
          appointPassList.push(pass);
          break;
        case "CLASS":
          classPassList.push(pass);
          break;
        case "PLACE":
          placePassList.push(pass);
          break;
        case "OPTION":
          optionPassList.push(pass);
          break;
      }

      if (pass.packagePass === "Y") {
        const key = JSON.stringify({ seqPackage: pass.seqPackage, seqPricing: pass.seqPricing });

        if (packageInfo.has(key)) {
          if (!packageInfo.get(key).packageSeqServiceList.includes(pass.seqService)) {
            packageInfo.set(key, {
              ...packageInfo.get(key),
              passList: [...packageInfo.get(key).passList, pass],
              serviceNames: [...packageInfo.get(key).serviceNames, pass.serviceName],
              packageSeqServiceList: [
                ...packageInfo.get(key).packageSeqServiceList,
                pass.seqService,
              ],
              packagePrice: (packageInfo.get(key).packagePrice += pass.price),
            });
          }
        } else {
          packageInfo.set(key, {
            seqPackage: pass.seqPackage,
            seqPricing: pass.seqPricing,
            packageName: pass.packageName,
            pricingName: pass.pricingName,
            packagePrice: pass.price,
            serviceNames: [pass.serviceName],
            passList: [pass],
            packageSeqServiceList: [pass.seqService],
          });
        }
      }
    });

    return {
      appointPassList,
      classPassList,
      placePassList,
      optionPassList,
      packageInfo,
    };
  };

  useEffect(() => {
    callApi(
      "/members/detail",
      {
        seqMember: state.memberDtlPopData.seqMember,
        seqPartner,
        seqPartnerBranch,
        seqPartnerCoach,
      },
      "GET"
    ).then((res) => {
      const { appointPassList, classPassList, placePassList, optionPassList, packageInfo } =
        processPassList(res.PassList);

      setMemoReadOnly(res.MemberDtlVO.memo);
      setMemberDtl({
        MemberDtlVO: res.MemberDtlVO,
        PartnerVO: res.PartnerVO,
        AppointPassList: appointPassList,
        ClassPassList: classPassList,
        PlacePassList: placePassList,
        OptionPassList: optionPassList,
        PackageInfo: packageInfo,
        discountPermission: res.discountPermission,
        salePermission: res.salePermission,
      });
    });
  }, []);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: false } });
  };

  const handleClickMemoPop = () => {
    callApi(
      "/members/permission/memo",
      {
        seqMember: state.memberDtlPopData.seqMember,
        seqPartner,
        seqPartnerBranch,
        seqPartnerCoach,
      },
      "GET"
    ).then((res) => {
      if (res.permission) {
        setMemo(res.memo);
        setMemoReadOnly(res.memo);
        dispatch({
          type: "POP_UP_OPEN",
          id: "CHOOSE_SCHEDULE_TYPE",
          open: { memoEditPop: true },
        });
      } else {
        dispatch({
          type: "ALERT_SETTING",
          data: {
            alert: true,
            cancleYn: false,
            redYn: false,
            header: "회원 메모",
            body: "회원 메모를 볼 수 있는 권한이 없습니다.",
            cancelAlert: () => ({}),
            closeAlert: () => ({}),
          },
        });
      }
    });
  };

  const handleChangeMemo = (memo: string) => {
    setMemo(blockEmoji(memo));
  };

  const handleClickUpdateMemo = () => {
    callApi(
      "/members/modify/memo",
      {
        seqMember: state.memberDtlPopData.seqMember,
        seqPartner,
        seqPartnerBranch,
        seqPartnerCoach,
        memo: memo,
      },
      "POST"
    ).then(() => {
      setMemoReadOnly(memo);
      dispatch({
        type: "POP_UP_OPEN",
        id: "CHOOSE_SCHEDULE_TYPE",
        open: { memoEditPop: false },
      });
      dispatch({ type: "UPDATE", data: { toast: true, toastText: "수정되었습니다." } });
    });
  };

  return (
    <Fragment>
      <PopupHeader title="회원정보" onClickBack={handleClose} />
      {MemberDtlVO?.useYn === "N" ? (
        <div className="popup-body member-dtl-pop">
          <MemberEmpty />
        </div>
      ) : (
        <div className="popup-body member-dtl-pop">
          <MemberDtl MemberDtlVO={MemberDtlVO} />
          <CenterList MemberDtlVO={MemberDtlVO} PartnerVO={PartnerVO} />
          <Memo
            title="회원 메모"
            placeHolder="회원 메모를 입력해 주세요 :)"
            memoContent={memo}
            memoReadOnly={memoReadOnly}
            onChangeMemo={handleChangeMemo}
            onClickUpdateMemo={handleClickUpdateMemo}
            onClickMemoPop={handleClickMemoPop}
          />
          <PassList
            MemberDtlVO={MemberDtlVO}
            ClassPassList={ClassPassList}
            AppointPassList={AppointPassList}
            PlacePassList={PlacePassList}
            OptionPassList={OptionPassList}
            PackageInfo={PackageInfo}
            discountPermission={discountPermission}
            salePermission={salePermission}
          />
        </div>
      )}
    </Fragment>
  );
};

const MemberDtlPopWrap = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: false } });
  };

  return (
    <CustomDialog open={state.memberDtlPop} onClose={handleClose}>
      <MemberDtlPop />
    </CustomDialog>
  );
};

export default MemberDtlPopWrap;
